// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_69-6";
export var headerCell = "_69-2";
export var rowWrapper = "_69-4";
export var stickyAggregationCell = "_69-a";
export var stickyAggregationRow = "_69-7";
export var stickyColumnCell = "_69-9";
export var stickyColumnHeaderCell = "_69-8";
export var table = "_69-1";
export var virtualRowWrapper = "_69-5";
export var virtualTableContainer = "_69-0";
export var white = "_69-3";